import moment from 'moment'

export const sampleJourney = {
    id: '',
    srNumber: '',
    sampleRequestId: '',
    product: '',
    customer: '',
    destination: '',
    address: '',
    scheduleProduct: '',
    remarkRS: '',
    remarkAQ: '',
    remarkSJ: '',
    completeDate: moment().format('YYYY-MM-DD'),
    startDate : moment().format('YYYY-MM-DD'),
    dueDate: moment().format('YYYY-MM-DD'),
    isApprovedRS: false,
    RSApprovedBy: '',
    RSapprovedByName: '',
    isApprovedAQ: false,
    AQapprovedBy : '',
    AQapprovedByName: '',
    statusId: '',
    statusName: ''
}

export const sampleJourneyDetail = {
    id: '',
    sampleRequestId: '',
    spec: '',
    qty: 0,
    UOM: '',
    sampleCostMT: 0,
    sampleCost: '',
    DG: false,
    courier : false,
    carrierCost: '',
    courierInformationNumber: '',
    paid : false,
    remark: ''
}

export const sampleJourneyGanttChart = {
    id: '',
    sampleRequestId: '',
    sequence: '',
    name: '',
    start: moment().format('YYYY-MM-DD'),
    end : moment().format('YYYY-MM-DD'),
}